const state = {
  visible: false,
};

const mutations = {
  show(state) {
    state.visible = true;
  },
  hide(state) {
    state.visible = false;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
